var _circle, _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    fill: "none",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    fill: "#E4F3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4EAEA5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M36.125 46.375h4.636a3.416 3.416 0 0 0 3.417-3.417V17.333c0-.943-.765-1.708-1.708-1.708h-3.173c-.943 0-1.708.765-1.708 1.708v3.94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4EAEA5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m15.625 28.803 13.15-11.271a3.416 3.416 0 0 1 4.447 0l13.153 11.271"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 4,
    x: 14,
    y: 43,
    fill: "#4EAEA5",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 4,
    x: 18,
    y: 37,
    fill: "#4EAEA5",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    x: 23,
    y: 31,
    fill: "#4EAEA5",
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup360);
export default __webpack_public_path__ + "static/media/group360.c83ad7be.svg";
export { ForwardRef as ReactComponent };